export const SESSION_TIMEOUT_MS = 1 * 60 * 60 * 1000; // 1 hour (60 minutes)

export const isSessionExpired = (lastActivity, now = Date.now(), timeoutMs = SESSION_TIMEOUT_MS) => {
  if (!lastActivity) return false; // If not set yet, do not falsely expire immediately

  const timestamp = Number(lastActivity);
  if (Number.isNaN(timestamp) || timestamp <= 0) return false;

  return now - timestamp > timeoutMs;
};

